import type { ShareCopy } from './share-flow';

// File sharing's half of the share-dialog machine: the copy, and nothing else.
//
// The logic lives in `lib/share-flow.ts` and is shared, deliberately — the rules it holds (a typo
// mints a person, "nothing was written" is a third outcome, a failed list read is not "private")
// are not about apps or files, and two copies of them would drift with only one getting the next
// fix. This file exists so that generic machine never has to know what a file is.
export const FILE_SHARE_COPY: ShareCopy = {
  invalidEmail: 'files.access.invalidEmail',
  shareFailed: 'files.access.failed',
  removeFailed: 'files.access.removeFailed',
  private: 'files.access.private',
  privateHint: 'files.access.privateHint',
  sharedWithOne: 'files.access.sharedWith.one',
  sharedWithOther: 'files.access.sharedWith.other',
  loadFailed: 'files.access.loadFailed',
  retry: 'files.access.retry',
  unnamed: 'files.access.unnamed',
};
